module.exports = __webpack_public_path__ + "static/media/ic_searchtype_boatramp.707060b5.svg";